/**
 * @generated SignedSource<<1dda89fde0bec80cb5526840c57afe60>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type commentPreviewDeleteCommentMutation$variables = {
  commentId: string;
};
export type commentPreviewDeleteCommentMutation$data = {
  readonly deleteComment: {
    readonly id: string;
  };
};
export type commentPreviewDeleteCommentMutation = {
  response: commentPreviewDeleteCommentMutation$data;
  variables: commentPreviewDeleteCommentMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "commentId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "commentId"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "commentPreviewDeleteCommentMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "deleteComment",
        "plural": false,
        "selections": [
          (v2/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "commentPreviewDeleteCommentMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "deleteComment",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "__typename",
            "storageKey": null
          },
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "filters": null,
            "handle": "deleteRecord",
            "key": "",
            "kind": "ScalarHandle",
            "name": "id"
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "5cb0a11d72780dfde6abc3ff3eb1963e",
    "id": null,
    "metadata": {},
    "name": "commentPreviewDeleteCommentMutation",
    "operationKind": "mutation",
    "text": "mutation commentPreviewDeleteCommentMutation(\n  $commentId: ID!\n) {\n  deleteComment(id: $commentId) {\n    __typename\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "43654a52d8ffa5a89f476ec8b8df7666";

export default node;
